import { StoreEnhancer } from '@reduxjs/toolkit';
import { NOTIFICATION_LS_KEY } from 'utils/NotificationInitializer';
import { userNotificationPush } from '../../domains/user/model/hooks';

type TResetStore = () => StoreEnhancer;

export const resetStore: TResetStore =
  () => (next) => (reducer, initialState) => {
    const enhanceReducer = (state: any, action: any) => {
      let newState = state;
      if (action.type === 'AUTH_LOGOUT_SUCCESS') {
        sessionStorage.clear();
        const { messaging } = userNotificationPush();
        if (messaging) {
          messaging.deleteToken();
          localStorage.removeItem('$push-token');
        }
        localStorage.removeItem('$user');
        localStorage.removeItem('$token');
        localStorage.removeItem(NOTIFICATION_LS_KEY);
        newState = {
          projectReducer: { ...state.projectReducer },
        };
      }

      return reducer(newState, action);
    };
    return next(enhanceReducer, initialState);
  };
